import Vue from 'vue';

const state = {
    contacts:{},
    contacttypes:{},
    groups:{},
    sources:{},
    categories:{},
    types:{},
    statuses:{},
    formerrors:{},
    projectuuid:null,
};

const getters = {
    getContacts: state => state.contacts,
    getContactTypes: state => state.contacttypes,
    getGroups: state => state.groups,
    getSources: state => state.sources,
    getCategories: state => state.categories,
    getTypes: state => state.types,
    getStatuses: state => state.statuses,
    getFormErrors: state => state.formerrors,
    getProjectUuid: state => state.projectuuid,
};

const actions = {
    addContact: (store, payload) => store.commit("CONTACT_ADD", payload),
    detachContact: (store, payload) => store.commit("CONTACT_DETACH", payload),
    setCategories: (store, payload) => store.commit("CATEGORIES_SET", payload),
    setContacts: (store, payload) => store.commit("CONTACTS_SET", payload),
    setContactTypes: (store, payload) => store.commit("CONTACTTYPES_SET", payload),
    setFormErrors: (store, payload) => store.commit("FORMERRORS_SET", payload),
    setGroups: (store, payload) => store.commit("GROUPS_SET", payload),
    setProjectUuid: (store, payload) => store.commit("PROJECTUUID_SET", payload),
    setSources: (store, payload) => store.commit("SOURCES_SET", payload),
    setStatuses: (store, payload) => store.commit("STATUSES_SET", payload),
    setTypes: (store, payload) => store.commit("TYPES_SET", payload),
};

const mutations = {
    CATEGORIES_SET: (state, payload) => state.categories = payload,
    CONTACT_ADD: (state, payload) => Vue.set(state.contacts, payload.contacttypeid, payload.contact),
    CONTACT_DETACH: (state, payload) => Vue.delete(state.contacts, payload),
    CONTACTS_SET: (state, payload) => state.contacts = payload,
    CONTACTTYPES_SET: (state, payload) => state.contacttypes = payload,
    FORMERRORS_SET: (state, payload) => state.formerrors = payload,
    GROUPS_SET: (state, payload) => state.groups = payload,
    SOURCES_SET: (state, payload) => state.sources = payload,
    TYPES_SET: (state, payload) => state.types = payload,
    STATUSES_SET: (state, payload) => state.statuses = payload,
    PROJECTUUID_SET: (state, payload) => state.projectuuid = payload,
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
